
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Description',
  components: {},
  props: {
    title: { type: String, default: '' },
    data: {
      type: Array,
      default: () => []
    },
    size: { type: String, default: 'small' },
    column: { type: Number, default: 3 }
  },
  setup() {
    return {}
  }
})
